import type { CoreConnectInvoicing } from '@flecto/types'

import { api } from '../../../services/api'

export async function connectInvoicing({
  payload
}: {
  payload: CoreConnectInvoicing
}): Promise<CoreConnectInvoicing> {

  const response = await api.post(
    '/api/me/integrations/invoices/connect',
    payload
  )

  return response.data
}

